import React, { Component } from 'react';
import WorkerInfoModal from './WorkerInfoModal';
import {
  fetchUserList,
  switchSelectedUser,
  fetchSelectedUserInfo
} from 'actions/UserActions';

class WorkerSelector extends Component {
  state = {
    filter: 0,
    modal: "OFF"
  }

  dismissModal = (e) => {
    this.setState({
      modal: "OFF"
    })
  }

  activeEditModal = (e) => {
    e.preventDefault();
    this.setState({
      modal: "EDIT"
    })
  }

  activeCreateModal = (e) => {
    e.preventDefault();
    this.setState({
      modal: "CREATE"
    })
  }

  changeUserFilter = (e) => {
    let filter = parseInt(e.target.value, 10);
    let {
      //userList, 
      dispatch
    } = this.props;
    //let selected = userList.findIndex(user => filter === -1 || user.get('status') === filter)
    dispatch(switchSelectedUser(0));
    this.setState({
      filter: filter
    })
  }

  handleUserSwitch = (e) => {
    let {dispatch} = this.props;
    dispatch(switchSelectedUser(e.target.value));
    dispatch(fetchSelectedUserInfo());
  }

  componentDidMount = () => {
    let {dispatch} = this.props;
    dispatch(fetchUserList());
  }

  render() {
    let {selected, userList, positionList, companyList, dispatch, loadingUserData} = this.props;
    let {filter, modal} = this.state;

    const WorkerFilter = () => (
      <select value={filter} onChange={this.changeUserFilter} className="form-control" disabled={loadingUserData} >
        <option value={-1}>全部</option>
        <option value={0}>在職</option>
        <option value={1}>離職</option>
      </select>
    )

    return (
      <div className="filter">
        <form className="form-inline">
          <div className="form-group">
            <WorkerFilter />
            {" "}
            <select
              value={selected}
              onChange={this.handleUserSwitch}
              disabled={loadingUserData}
              className="form-control"
            >
              <option value={0} key={0} disabled>
                      --請選擇員工--
              </option>
              {userList
                .filter(user => filter === -1 || user.get('status') === filter)
                .map((user) => {
                  let uid = user.get('uid');
                  let name = user.get('name');
                  return (
                    <option value={uid} key={uid}>
                      {uid}-{name}
                    </option>
                  )})
              }
            </select>
          </div>
          {" "}
          <button className="btn btn-default" onClick={this.activeEditModal} disabled={selected === 0}>
            員工資料
          </button>

          <button className="btn btn-primary pull-right" onClick={this.activeCreateModal}>
            新增員工
          </button>
        </form>
        {modal !== "OFF" &&
          <WorkerInfoModal
            dispatch={dispatch}
            selected={selected}
            companyList={companyList}
            positionList={positionList}
            mode={modal}
            dismissModal={this.dismissModal}
          />}
      </div>
    )
  }
}

export default WorkerSelector;



// WEBPACK FOOTER //
// ./src/components/Worker/WorkerSelector.js